import type { Guide } from '../../types';

import healthProfile from '../partials/healthProfile';

export default (async args => {
  await healthProfile(args);

  return {};
}: Guide);
